import React, { ReactElement } from "react";
import Box from "@mui/material/Box";
import { Grid } from "@mui/material";
import CssBaseline from "@mui/material/CssBaseline";
import MetaTags from "components/MetaTags";
import AppHeaderPublic from "./public.header";

const PublicLayout: React.FC<{
  title: string;
  children?: ReactElement;
}> = ({ children, title = "" }) => {
  return (
    <>
      <MetaTags title={title} />
      <CssBaseline />
      <AppHeaderPublic />
      <Box component="main" className="admin-layout-box-container">
        <Grid container alignContent="start" style={{ paddingInline: 0 }}>
          {children}
        </Grid>
      </Box>
    </>
  );
};
export default PublicLayout;
